import { Box } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useLoggedInUser } from '../../../../app/hooks/useLoggedInUser'
import Documents from '../../../Documents/Documents'
import MainInfo from '../MainInfo'

interface ProductDetailsProps {
  isDisabled?: boolean
  customerId?: number
}

const ProductDetails = ({ isDisabled, customerId }: ProductDetailsProps) => {
  const { watch } = useFormContext()
  const productId = watch('id')

  const { tenantId } = useLoggedInUser()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <MainInfo isDisabled={isDisabled} customerId={customerId} />
      <Box sx={{ width: '50%', ml: '16px' }}>
        <Documents
          categoryId={3}
          entityId={productId}
          customerId={customerId}
          tenantId={tenantId}
          isDisabled={isDisabled}
        />
      </Box>
    </Box>
  )
}

export default ProductDetails
